module.exports = __webpack_public_path__ + "img/blueprint-old-house.2258c65f.jpg";